export const cifSt = ["301 151","<g fill-rule='nonzero' fill='none'><path fill='#12AD2B' d='M.5.5h300v150H.5z'/><path fill='#FFCE00' d='M.5 43.357h300v64.286H.5z'/><path fill='#D21034' d='M.5.5v150l75-75'/><path fill='#000' d='M130.12 68.878l12.596 9.151-4.811 14.807 12.595-9.151 12.596 9.151-4.811-14.807 12.595-9.151h-15.569L150.5 54.071l-4.811 14.807zM205.12 68.878l12.596 9.151-4.811 14.807 12.595-9.151 12.596 9.151-4.811-14.807 12.595-9.151h-15.569L225.5 54.071l-4.811 14.807z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-st.js
// module id = null
// module chunks = 